import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../Views/HomeView.vue";
import AboutView from "../Views/AboutView.vue";
import CareersView from "../Views/CareersView.vue";
import ProcessView from "../Views/ProcessView.vue";
import FindLoanView from "../Views/FindLoan.vue"
import LoanPurchaseView from "../Views/LoanPurchaseView.vue"
import LoanRefinanceView from "../Views/LoanRefinanceView.vue"
import LoanConventional from "../Views/ConventionalView.vue"
import FHAView from "../Views/FHAView.vue"
import VAView from "../Views/VAView.vue"
import JumboView from "../Views/Jumbo.vue"
import CondoView from "../Views/CondoView.vue"
import RuralView from "../Views/RuralView.vue"
import CashOutView from "../Views/CashOutView.vue"
import NonQMView from "../Views/NonQMView.vue"
import CalculatorView from "../Views/CalculatorView.vue"
import LoanOfficers from "../Views/LoanOfficers.vue";
import Locations from "../Views/Locations.vue";
import Divisions from "../Views/DivisionsView.vue";
import TermsOfUse from "@/Views/TermsOfUse.vue";
import ConsumerPrivacyPolicy from "@/Views/ConsumerPrivacyPolicy.vue";
import WebsitePrivacy from "@/Views/WebsitePrivacy.vue";
import CompanyStateLicenses from "@/Views/CompanyStateLicenses.vue";
import CPRAPrivacy from "@/Views/CPRAPrivacy.vue";
import VetLife from "@/Views/VetlifeView.vue"
import SpoofView from "@/Views/SpoofView.vue";
import EmploymentView from "@/Views/EmploymentView.vue";
<head>
<link rel="preconnect" href="https://fonts.googleapis.com"></link>
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700&display=swap" rel="stylesheet"></link>
</head>

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: 'Home' }
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
    meta: { title: 'About' }
  },
  {
    path:"/careers",
    name: "careers",
    component: CareersView,
    meta: { title: 'Careers' }
  },
  {
    path:"/process",
    name: "process",
    component: ProcessView,
    meta: { title: 'Our Process' }
  },
  {
    path:"/find-loan",
    name:"loan",
    component: FindLoanView,
    meta: { title: 'Find a Loan' }
  },
  {
    path:"/find-loan/purchase",
    name:"purchase",
    component: LoanPurchaseView,
    meta: { title: 'Find a Loan' }
  },
  {
    path:"/find-loan/refinance",
    name:"refinance",
    component: LoanRefinanceView,
    meta: { title: 'Find a Loan' }
  },
  {
    path:"/find-loan/conventional",
    name:"conventional",
    component: LoanConventional,
    meta: { title: 'Conventional' }
  },
  {
    path:"/find-loan/FHA",
    name:"fha",
    component: FHAView,
    meta: { title: 'FHA' }
  },
  {
    path:"/find-loan/VA",
    name:"va",
    component: VAView,
    meta: { title: 'VA' }
  },
  {
    path:"/find-loan/Jumbo",
    name:"jumbo",
    component: JumboView,
    meta: { title: 'Jumbo' }
  },
  {
    path:"/find-loan/Condo",
    name:"condo",
    component: CondoView,
    meta: { title: 'Condo' }
  },
  {
    path:"/find-loan/Rural",
    name:"rural",
    component: RuralView,
    meta: { title: 'Rural' }
  },
  {
    path:"/find-loan/CashOut",
    name:"cashout",
    component: CashOutView,
    meta: { title: 'Cash Out' }
  },
  {
    path:"/find-loan/NonQM",
    name:"nonqm",
    component: NonQMView,
    meta: { title: 'Non-QM' }
  },
  {
    path:"/calculators",
    name:"calculators",
    component: CalculatorView,
    meta: { title: 'Calculators' }
  },
  {
    path:"/loan-officers",
    name:"loan-officers",
    component: LoanOfficers,
    meta: { title: 'Loan Officers' }
  },
  {
  path:"/locations",
  name:"locations",
  component: Locations,
  meta: { title: 'Locations' }
  },
  {
  path:"/divisions",
  name:"divisions",
  component: Divisions,
  meta: { title: 'Divisions' }
  },
  {
  path:"/termsofuse",
  name:"termsofuse",
  component: TermsOfUse,
  meta: { title: 'Terms of Use' }
  },
  {
  path:"/consumerprivacy",
  name:"consumerprivacy",
  component: ConsumerPrivacyPolicy,
  meta: { title: 'Consumer Privacy Policy'}
  },
  {
  path:"/websiteprivacy",
  name:"websiteprivacy",
  component: WebsitePrivacy,
  meta: { title: 'Website Privacy Policy'}
  },
  {
  path:"/companystatelicense",
  name:"companystatelicense",
  component: CompanyStateLicenses,
  meta: { title: 'Company State Licenses'}
  },
  {
    path:"/cpraprivacy",
    name:"cpraprivacy",
    component: CPRAPrivacy,
    meta: { title: 'CPRA Privacy'}
  },
  {
    path:"/vetlife",
    name:"vetlife",
    component: VetLife,
    meta: { title: 'VetLife'}
  },
  {
    path:"/consumeralert",
    name:"consumeralert",
    component: SpoofView,
    meta: { title: 'Consumer Alert'}
  },
  {
  path:"/positions",
  name:"positions",
  component: EmploymentView,
  meta: { title: 'Open Positions '}
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Default Page Title';
  next();
});

export default router;

